let keyBuffer = '';
let keyTimeout: number;
const bufferTime = 5000;

const resetBuffer = () => {
  keyBuffer = '';
};

export const insertNumber = (keycode: number) => {
  if (keyTimeout) window.clearTimeout(keyTimeout);
  keyTimeout = window.setTimeout(resetBuffer, bufferTime);

  const key = (keycode - 48).toString();
  const buffer = keyBuffer.length < 8 ? (keyBuffer += key) : key;
  return buffer;
};
